/**
 * Shared add-to-cart feedback: header count/total sync, cart icon bump,
 * cart drawer refresh + open, and a fallback toast for non-drawer setups.
 * Consumed by component-product-item.js, products-carousel-main.js and
 * featured-products-carousel.js so all add-to-cart entry points behave the same.
 */

if (typeof window.CartFeedback === 'undefined') {

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function updateCartCount() {
    return fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        document.querySelectorAll('[data-header-cart-count]').forEach((el) => {
          el.textContent = cart.item_count;
        });
        document.querySelectorAll('[data-header-cart-total]').forEach((el) => {
          el.textContent = formatMoney(cart.total_price);
        });
        if (typeof window.theme !== 'undefined' && window.theme.cart) {
          window.theme.cart.refresh();
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        return cart;
      })
      .catch((err) => console.error('Error updating cart count:', err));
  }

  function showNotification(message) {
    const existing = document.querySelector('.product-item-cart-notification');
    if (existing) existing.remove();

    const notification = document.createElement('div');
    notification.className = 'product-item-cart-notification';
    notification.innerHTML =
      '<span class="product-item-cart-notification__message"></span>' +
      '<a class="product-item-cart-notification__action" href="' + ((window.KROWN && window.KROWN.settings.routes.cart_url) || '/cart') + '">View Cart</a>';
    notification.querySelector('.product-item-cart-notification__message').textContent = message;

    document.body.appendChild(notification);
    requestAnimationFrame(() => notification.classList.add('is-visible'));

    setTimeout(() => {
      notification.classList.remove('is-visible');
      setTimeout(() => notification.remove(), 300);
    }, 3500);
  }

  function bumpCartIcons() {
    document.querySelectorAll('[data-cart-icon-trigger]').forEach((el) => {
      el.classList.remove('cart-icon-bump');
      void el.offsetWidth;
      el.classList.add('cart-icon-bump');
      el.addEventListener('animationend', () => el.classList.remove('cart-icon-bump'), { once: true });
    });
  }

  function refreshCartDrawer() {
    return fetch('?section_id=helper-cart')
      .then((r) => r.text())
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const cartItems = document.getElementById('AjaxCartForm');
        const cartFormSource = doc.getElementById('AjaxCartForm');
        if (cartItems && cartFormSource) {
          cartItems.innerHTML = cartFormSource.innerHTML;
          if (typeof cartItems.ajaxifyCartItems === 'function') cartItems.ajaxifyCartItems();
        }

        const subtotalEl = document.getElementById('AjaxCartSubtotal');
        const subtotalSource = doc.getElementById('AjaxCartSubtotal');
        if (subtotalEl && subtotalSource) subtotalEl.innerHTML = subtotalSource.innerHTML;
      });
  }

  function openCartDrawer() {
    const sidebar = document.getElementById('site-cart-sidebar');
    if (!sidebar) return false;
    if (!window.KROWN || window.KROWN.settings.cart_action !== 'overlay') return false;
    if (document.body.classList.contains('template-cart')) return false;

    refreshCartDrawer().then(() => sidebar.show());
    return true;
  }

  function notifyAdded(message) {
    const drawerOpened = openCartDrawer();
    if (!drawerOpened) {
      showNotification(message);
    }
  }

  window.CartFeedback = {
    formatMoney,
    updateCartCount,
    bumpCartIcons,
    openCartDrawer,
    notifyAdded,
  };

}
